import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { AutenticacionService } from './_services/autenticacion.service';
import moment from 'moment';
import 'moment/locale/es';
import { NavService } from './_services/_nav.service';
import {Message, MessageService, PrimeNGConfig} from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppSettings } from '../proyect.conf';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import {forkJoin, Subscription} from 'rxjs';
import { filter } from 'rxjs/operators';
import { Dropdown } from 'primeng/dropdown';
import {ConstanteService} from './_services/constante.service';

declare var gtag;
@Component( {
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.css' ]
} )

export class AppComponent implements OnInit, OnDestroy {
  /**
   * Establece si la barra lateral se visualiza o se oculta.
   */
  barLateralActiva: boolean;
  /**
   * Orientación del menu.
   */
  orientacion: boolean;
  /**
   * Estado de la sesión.
   */
  estSesion: boolean;

  msgs: Message[] = [];

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  display = false;
  private subscripcion: Subscription;
  verToken: any;
  /** Variable para controlar el bug de primeng version 16 ****/
  isDropdownProcessing = false;


  constructor( private traService: TranslateService,
               private router: Router,
               private navServicio: NavService,
               private autServicio: AutenticacionService,
               private spinnerServicio: NgxSpinnerService,
               private idle: Idle,
               private keepalive: Keepalive,
               private messageService: MessageService,
               private config: PrimeNGConfig,
               private constanteService: ConstanteService) {
    /**
     * Implementacion de google analytics
     * */
    const navEndEvents$ = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      );

    navEndEvents$.subscribe((event: NavigationEnd) => {

      gtag('create', AppSettings.googleAnalyticsId, 'auto');
      gtag('set', 'page', event.urlAfterRedirects);
      gtag('send', 'pageview');
    });
  }

  crearGoogleMaps(){
    const DSLScript = document.createElement('script');
    DSLScript.src = 'https://maps.googleapis.com/maps/api/js?key=' + AppSettings.googleMapsKey + '&libraries=drawing';
    DSLScript.type = 'text/javascript';
    DSLScript.async = true;
    DSLScript.defer = true;
    document.body.appendChild(DSLScript);
  }

  ngOnInit() {
    this.prevenirStackOverflowPrimeNgApp();
    this.crearGoogleMaps();
    this.crearClarity();
    this.cargarYouTubeAPI();
    this.actualizarEstadoSesion( this.autServicio.estaLogueado() );
    if ( AppSettings.produccion ) {
      this.validarCargaInicial();
    }
    this.traService.setDefaultLang( 'es' );
    this.traService.use( 'es' );
    this.traService.get('primeng').subscribe(res => this.config.setTranslation(res));
    this.navServicio.getMessage$.subscribe(
      msgs => {
        this.msgs = msgs;
      } );
    this.config.setTranslation({
      accept: 'Accept',
      reject: 'Cancel',
      today: "hoy",
      clear: "Limpiar"
      //translations
    });
    this.navServicio.getMessageToast$.subscribe(
      msgs => {
        this.messageService.add(msgs[0]);
      } );
    moment.locale( 'es' );
    this.cargarDatosIp();

    // sets an idle timeout of 5 seconds, for testing purposes.
    this.idle.setIdle( AppSettings.tiempoInactividad );
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    this.idle.setTimeout( 30 );
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts( DEFAULT_INTERRUPTSOURCES );

    this.idle.onIdleEnd.subscribe( () => this.display = false );
    this.idle.onTimeout.subscribe( () => {
      this.display = false;
      this.cerrarSesion();
      this.timedOut = true;
      this.reset();
    } );

    this.config.setTranslation({
      emptyFilterMessage: 'No se encontraron resultados',
      emptySearchMessage: 'No se encontraron resultados'
    });


    this.idle.onIdleStart.subscribe( () => {
      if ( this.router.routerState.snapshot.url !== '/ingreso' ) {
        this.display = true;
      }
    } );

    this.idle.onTimeoutWarning.subscribe( ( countdown: number ) => {
      if ( countdown > 60 ) {
        let tiempo = countdown / 60;
        this.idleState = tiempo.toFixed( 1 ).toString() + ' minutos';
      } else {
        let tiempo = countdown;
        this.idleState = tiempo.toFixed( 0 ).toString() + ' segundos';
      }
    } );

    // sets the ping interval to 15 seconds
    this.keepalive.interval( 15 );

    // keepalive.onPing.subscribe( () => console.log( 'Last ping: ' + new Date() ) );

    this.reset();


    // if ( !this.estSesion ) {
    //   this.router.navigate( [ 'ingreso' ] );
    // }
    this.subscripcion = this.router.events.subscribe( event => {
      if ( event instanceof RouteConfigLoadStart ) {
        this.spinnerServicio.show();
      } else if ( event instanceof RouteConfigLoadEnd ) {
        this.spinnerServicio.hide();
      }
    } );
  }

  prevenirStackOverflowPrimeNgApp(){
    const origShow = Dropdown.prototype.show;
    const origHide = Dropdown.prototype.hide;

    Dropdown.prototype.show = function () {
      if (!this.isDropdownProcessing) {
        this.isDropdownProcessing = true;
        origShow.apply(this, arguments);
        setTimeout(() => {
          this.isDropdownProcessing = false;
        }, 250);
      }
    };

    Dropdown.prototype.hide = function () {
      if (!this.isDropdownProcessing) {
        this.isDropdownProcessing = true;
        origHide.apply(this, arguments);
        setTimeout(() => {
          this.isDropdownProcessing = false;
        }, 250);
      }
    };
  }

  ngAfterViewInit(){
    this.traService.get('primeng').subscribe(res => this.config.setTranslation(res));
  }

  crearClarity(){
    try{
      const DSLScript = document.createElement('script');
      DSLScript.innerHTML = '(function(c,l,a,r,i,t,y){\n' +
        '        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n' +
        '        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;\n' +
        '        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n' +
        '    })(window, document, "clarity", "script", "' + AppSettings.clarityId +'");';

      const head = document.getElementsByTagName('head')[0];
      if (head) {
        document.head.appendChild(DSLScript);
      }
    } catch ( e ) {
      console.log('Error cargar CLARITY');
      console.log(e);
    }
  }

  cargarYouTubeAPI(): void {
    try {
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Cambia la orientación del menu.
   * @param {boolean} tipo
   */
  cambioOrientacionMenu( tipo: boolean ) {
    this.orientacion = tipo;
  }

  /**
   * Controla la visualizaicón de la barra lateral del menu.
   * @param {boolean} estado
   */
  cambioEstadoBarraLateral( estado: boolean ) {
    this.barLateralActiva = estado;
  }

  /**
   * Actualiza el estado de sesión
   * @param {boolean} estNuevo
   */
  actualizarEstadoSesion( estNuevo: boolean ) {
    this.estSesion = estNuevo;
    if ( this.estSesion ) {
      this.refrescarToken();
      this.cargarLlaveFacetec();
    } else {
      this.limpiarIntervaloToken();
    }
  }

  cargarLlaveFacetec() {
    this.constanteService.getByCode('KFTWEB').subscribe( res => {
      if(res && res.indicadorHabilitado && res.valor){
        // console.log( AppSettings.facetecKeyProduccion );
        const llave = JSON.parse(res.valor);
        AppSettings.facetecKeyProduccion = llave;
        // console.log( AppSettings.facetecKeyProduccion );
      }
    });
  }

  refrescarToken() {
    const tieFaltante = this.autServicio.obtenerTiempoExpiracion();
    if ( tieFaltante - 30000 > 0 ) {
      this.verToken = setInterval( () => {
        this.autServicio.refrescarToken().subscribe( rta => {
          if ( rta && rta.estado ) {
            this.autServicio.actualizarToken( rta.respuesta );
            this.actualizarIntervalo();
          } else {
            this.cerrarSesion();
          }
        } );
      }, (tieFaltante - 30000) );
    }
  }

  actualizarIntervalo() {
    this.limpiarIntervaloToken();
    this.refrescarToken();
  }

  /**
   * Función que hace Reset al tiempo del idleMonitor
   */
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  validarCargaInicial() {
    if ( this.estSesion ) {
      this.router.navigate( [ 'dashboard' ] );
    }
  }

  cerrarSesion() {
    this.autServicio.cerrarSesion();
    window.location.href = '/ingreso';
  }

  async cargarDatosIp() {
    localStorage.removeItem('ipLocal');
    localStorage.removeItem( 'ipClient');
    forkJoin(this.autServicio.obtenerIpPublica(), this.autServicio.obtenerIpPrivada()).subscribe();
  }

  limpiarIntervaloToken() {
    clearInterval( this.verToken );
  }

  ngOnDestroy(): void {
    this.limpiarIntervaloToken();
    if ( this.subscripcion ) {
      this.subscripcion.unsubscribe();
    }
  }


}
